export default __webpack_public_path__ + "static/assets/cded18a2d032b0ea8d84d2707b612173.gif";